import { Searches } from '~/types/searches';
import getCanonicalSearch from './getCanonicalSearch';
export const isSingleCodeSearch = (search: Searches.SearchObject) => {
  if (!search) {
    return false;
  }
  const canonicalSearch = getCanonicalSearch(search);
  return (
    canonicalSearch.all.length === 1 &&
    canonicalSearch.any.length === 0 &&
    canonicalSearch.none.length === 0 &&
    canonicalSearch.all[0]?.type === 'code'
  );
};
